import { defineStore } from 'pinia'
import state from './common.state'
import getters from './common.getters'
import actions from './common.actions'

/**
 * Returns Common store
 */
export const useCommonStore = defineStore('common', {
  state: () => state,
  getters,
  actions
})
